import aboutUsRoutes from '@about-us/routes'
import adminToolsRoutes from '@admin-tools/routes'
import externalAuthRoutes from '@auth/externalRoutes'
import authRoutes from '@auth/routes'
import buybackRoutes from '@buyback/routes'
import buyingGuidesRoutes from '@buying-guide/routes'
import { checkoutRoutes } from '@checkout'
import cmsRoutes from '@cms/routes'
import customerRequestsB2CRoutes from '@customer-requests/B2CRoutes'
import customerRequestsRoutes from '@customer-requests/routes'
import dashboardRoutes from '@dashboard/routes'
import helpCenterRoutes from '@help-center/routes'
import homeRoutes from '@home/routes'
import landingRoutes from '@landing/routes'
import legalRoutes from '@legal/routes'
import merchantRoutes from '@merchant/routes'
import packageTrackingRoutes from '@package-tracking/routes'
import paymentRoutes from '@payment/routes'
import productComparisonRoutes from '@product-comparison/routes'
import productRoutes from '@product/routes'
import reviewsRoutes from '@reviews/routes'
import studentDiscountRoutes from '@student-discount/routes'

// Module routers to import
const modulesRoutesBusinessToCustomers = [
  authRoutes,
  aboutUsRoutes,
  buyingGuidesRoutes,
  cmsRoutes,
  customerRequestsB2CRoutes,
  studentDiscountRoutes,
  checkoutRoutes,
  buybackRoutes,
  landingRoutes,
  paymentRoutes,
  legalRoutes,
  dashboardRoutes,
  // TODO [CIC-856] To enable when the epic is done
  // helpCenterRoutes,
  packageTrackingRoutes,
  productComparisonRoutes,
  productRoutes,
  reviewsRoutes,
]

const modulesRoutesBusinessToBusiness = [
  adminToolsRoutes,
  externalAuthRoutes,
  merchantRoutes,
  customerRequestsRoutes,
]

const createRoutes = (routes, context) =>
  routes.map((getModuleRoutes) => getModuleRoutes(context)).flat()

const createRoutesWithLocale = (routes, context) => {
  return [
    {
      // For now, we only support 1 locale per country
      path: `/:locale(${context.locale})`,
      // Render nothing
      component: { render: (h) => h('router-view') },
      children: [
        ...routes
          .map((getModuleRoutes) => {
            // TODO: Remove the map when all of the URLs are migrated using the locale
            return getModuleRoutes(context).map((route) => ({
              ...route,
              // Remove first slash from path of all children routes
              path: route.path.replace(/^\//g, ''),
            }))
          })
          .flat(),
      ],
    },
  ]
}

export const getModulesRoutes = (context) => {
  const { FF_HELP_CENTER, FF_NEW_URL_FORMAT } = context.config

  let routes = [
    // Home has to be initialized separately to remove the trailing slash
    ...homeRoutes(context),
    ...createRoutes(modulesRoutesBusinessToBusiness, context),
  ]

  // TODO [CIC-856] To remove when the epic is done (see line 35)
  if (FF_HELP_CENTER) {
    routes = [...routes, ...createRoutes([helpCenterRoutes], context)]
  }

  // TODO: Remove as part of BROW-1373
  if (FF_NEW_URL_FORMAT.includes(context.country)) {
    return [
      ...routes,
      ...createRoutesWithLocale(modulesRoutesBusinessToCustomers, context),
    ]
  }

  return [...routes, ...createRoutes(modulesRoutesBusinessToCustomers, context)]
}
